import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_textarea, {
      variant: "solo",
      flat: "",
      "hide-details": "",
      rows: "1",
      "auto-grow": "",
      name: "comment",
      placeholder: _ctx.$t('comment.placeholder'),
      "prepend-inner-icon": "mdi-note-outline",
      modelValue: _ctx.inputComment,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputComment) = $event)),
      clearable: "",
      class: "comment-area",
      style: {"white-space":"pre-wrap"}
    }, null, 8, ["placeholder", "modelValue"]),
    _createVNode(_component_v_btn, {
      color: "primary",
      variant: "text",
      onClick: _ctx.saveComment,
      loading: _ctx.commentLoading
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('comment.save')), 1)
      ]),
      _: 1
    }, 8, ["onClick", "loading"])
  ]))
}